/* eslint no-param-reassign: 0 */
import { formatDisplayPrice } from 'client/GrowthEngineering/utilities/CheckoutUtil';
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    answers: {},
  },
  actions: {
    resetAnswers({ commit }) {
      commit('RESET_ANSWERS');
    },
    setAnswers({ commit }, answers) {
      commit('SET_ANSWERS', answers);
    },
  },
  getters: {
    getMonthlyRate(state, getters) {
      const hasListPrice = !!getters.getPlanDetails.listPrice;
      const hasAdequateUserCount = state.answers.usersCount && state.answers.usersCount > 10;
      const hasMonthlyRateRecomendation = hasListPrice && hasAdequateUserCount;

      return hasMonthlyRateRecomendation
        ? getters.getPlanDetails.listPrice * state.answers.usersCount
        : 0;
    },
    getAnnualRate(state, getters) {
      const hasAnnualPrice = !!getters.getPlanDetails.annualPrice;
      const hasAdequateUserCount = state.answers.usersCount && state.answers.usersCount > 10;
      const hasAnnualRateRecomendation = hasAnnualPrice && hasAdequateUserCount;

      return hasAnnualRateRecomendation
        ? getters.getPlanDetails.annualPrice * state.answers.usersCount
        : 0;
    },
    getMonthlyRateDisplayText(state, getters) {
      return formatDisplayPrice(getters.getMonthlyRate);
    },
    getAnnualRateDisplayText(state, getters) {
      return formatDisplayPrice(getters.getAnnualRate, true);
    },
    getMonthlyTotalCostDisplayText(state, getters, rootState) {
      const { isAnnual } = rootState.PricingModule.item;
      if (isAnnual) {
        return formatDisplayPrice(getters.getAnnualRate);
      }
      return getters.getMonthlyRateDisplayText;
    },
    getAnswers(state) {
      return state.answers;
    },
    getPlanDetails(state, getters, rootState, rootGetters) {
      const {
        sso,
        coreDirectory,
        platform,
        platformPlus,
      } = rootGetters['SubscriptionCollection/getSubscriptionObjects'];
      let planDetails;

      if (!state.answers) {
        planDetails = '';
      } else if (state.answers.conditionalAccess === 'yes') {
        planDetails = platformPlus;
      } else if (state.answers.reportCompliance !== 'never'
        || state.answers.mac || state.answers.windows || state.answers.linux) {
        planDetails = platform;
      } else if (state.answers.networkEquipment === 'yes' || state.answers.legacy === 'yes') {
        planDetails = coreDirectory;
      } else if (state.answers.sso === 'yes' || state.answers.mfa === 'yes') {
        planDetails = sso;
      } else {
        planDetails = '';
      }

      return planDetails;
    },
  },
  mutations: {
    RESET_ANSWERS(state) {
      state.answers = {};
    },
    SET_ANSWERS(state, answers) {
      Object.keys(answers).forEach((field) => {
        Vue.set(state.answers, field, answers[field]);
      });
    },
  },
};
